import './SocialSquareRotatorSlide.scss';
import { JUNOContent } from '../../../types/global';
import { Accessibility } from '../../../utils/Accessibility/Accessibility';
export default class SocialSquareRotatorSlide extends BaseSlide {
  mDiv: JQuery<HTMLElement>;
  mContent: JUNOContent;
  mConstructorParams: any;
  constructor() {
    super();
  }

  generateHtml(): void {
    this.mContent = this.mStruct;

    let htmlStruct = {
      style: 'ui_absolute socialsquarerotator_slide',
      children: [
        {
          style: 'socialsquarerotator_slide_title',
          children: [
            {
              style: 'socialsquarerotator_slide_title_text',
              if:
                !this.mConstructorParams.hideSlideTitles &&
                this.mContent.TopicName != null &&
                this.mContent.TopicName != '',
              interior: this.mContent.TopicName,
            },
          ],
        },
        {
          style: 'socialsquarerotator_slide_body',
          children: [
            {
              style: 'social_post_text_container',
              children: [
                {
                  style: 'social_post_text',
                  interior: this.mContent.SocialDescription,
                },
              ],
            },
            {
              style: 'social_post_image',
            },
          ],
        },
        {
          style: 'socialsquarerotator_slide_footer',
          children: [
            {
              style: 'social_author_data',
              children: [
                // thumbnail, fname+lname, "released"
                {
                  style: 'icon_container cover',
                },
                {
                  style: 'sub_container',
                  children: [
                    {
                      style: 'name',
                      interior: HGEN.span({
                        interior: this.mContent.Author?.Firstname + ' ' + this.mContent.Author?.Lastname,
                      }),
                    },
                    {
                      style: 'poster_info',
                      interior: this.mContent.DateLiteralReleased,
                    },
                  ],
                },
              ],
            },
            {
              // num likes, num comments added in _addSocialActionsContainer
              style: 'social_post_data',
            },
          ],
        },
      ],
    };

    this.mDiv = $(HGEN.tree(htmlStruct));

    this._addImagesToSlide();
    this._setupEventListeners();
    this._addSocialActionsContainer();
  }

  private _addImagesToSlide(): void {
    this.mDiv
      .find('.icon_container')
      .css('background-image', 'url(' + App.INSTANCE.getImageSrc(this.mContent.Author?.Icon) + ')');

    if (this.mContent.Image != '') {
      this.mDiv.find('.social_post_text_container').addClass('with_post_image');
      let hgenImg = HGEN.image({
        style: '',
        sizes: '100px', //setting max size to 100px here since the image is inside of a slide card
        srcSet: this.mContent.ImageSrcSet,
      });
      this.mDiv.find('.social_post_image').html(hgenImg);
    } else {
      this.mDiv.find('.social_post_image').hide();
    }
  }

  private _setupEventListeners(): void {
    Accessibility.clickAndKeypress(this.mDiv, () => {
      if (this.mContent.FirstBucketName() == CrowdHub_App.BUCKET_COMMUNITY) {
        let url = App.INSTANCE.appRouter.generate('navigate.connect.grouppost', {
          parent_id: -1,
          feed_id: this.mContent.Id,
        });
        App.INSTANCE.route(url);
      } else if (this.mContent.FirstBucketName() == CrowdHub_App.BUCKET_FORUMTOPIC) {
        let url = App.INSTANCE.appRouter.generate('navigate.connect.forumtopic', { parent_id: this.mContent.Id });
        App.INSTANCE.route(url);
      } else if (this.mContent.FirstBucketName() == CrowdHub_App.BUCKET_FORUMPOST) {
        let url = App.INSTANCE.appRouter.generate('navigate.connect.forumpost', {
          parent_id: this.mContent.TopicId,
          feed_id: this.mContent.Id,
        });
        App.INSTANCE.route(url);
      } else {
        // fallback for anything random ie content added to the slide
        if (this.mConstructorParams.onClickedSlide != null) {
          this.mConstructorParams.onClickedSlide(self);
        }
      }
    });
  }

  private _addSocialActionsContainer(): void {
    let socialLike = new SocialLikeContainer();
    socialLike.initialize({
      text: '',
      count: this.mContent.GetActionByType(CrowdHub_App.ACTION_FAVORITE)?.TotalCompleted,
      container: this.mDiv.find('.social_post_data'),
    });
    let socialComment = new SocialCommentContainer();
    socialComment.initialize({
      text: '',
      count: this.mContent.NumResponses,
      container: this.mDiv.find('.social_post_data'),
    });
  }
}
